/**
 * 微信扫码登录回调页面
 * 获取 code 和 state 后，通过 postMessage 通知父页面
 */
import { useEffect } from "react";

function RedirectPage() {
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    if (window.parent) {
      window.parent.postMessage(
        { type: "weixin-scan-login-success", data: { code, state } },
        location.origin
      );
    }
  }, []);

  return <div className="w-full h-full"></div>;
}

export default RedirectPage;
